import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import { browserHistory } from 'react-router';
import { FaHardHat, FaTshirt } from 'react-icons/fa';

// Inject animated gradient keyframes once
const ensureGradientKeyframes = () => {
  if (typeof document === 'undefined') return;
  if (document.getElementById('pj-gradient-anim')) return;
  const style = document.createElement('style');
  style.id = 'pj-gradient-anim';
  style.innerHTML = `
    @keyframes gradientBackground {
      0% { background-position: 0% 50%; }
      50% { background-position: 100% 50%; }
      100% { background-position: 0% 50%; }
    }
  `;
  document.head.appendChild(style);
};
ensureGradientKeyframes();

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: 'linear-gradient(270deg, #008e6a, #00a77d, #D22328, #0099ff)',
    backgroundSize: '800% 800%',
    animation: 'gradientBackground 15s ease infinite',
    color: '#FFF',
    fontFamily: "'Montserrat', sans-serif",
    padding: '20px',
    textAlign: 'center',
    transition: 'opacity 0.5s ease',
    opacity: 0.95,
  },
  header: {
    margin: '0 0 20px 0',
    fontSize: '2.5em',
    fontWeight: 'bold',
  },
  description: {
    fontSize: '1.2em',
    maxWidth: '600px',
    lineHeight: '1.5',
  },
  button: {
    fontSize: '1em',
    padding: '15px 30px',
    backgroundColor: '#FFF',
    color: '#008e6a',
    border: '2px solid #FFF',
    borderRadius: '50px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-block',
    marginTop: '20px',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease',
  },
};

interface Props {}
interface State {}

class ViewPapaJohnsDesignsUC extends React.Component<Props, State> {
  handleCTA = () => {
    browserHistory.push(Tgcc.Routes.PapaJohnsShirtOfTheMonthClub);
  };

  render() {
    return (
      <div style={styles.container}>
        <h1 style={styles.header}>
          <FaHardHat style={{ marginRight: '10px', verticalAlign: 'middle', fontSize: '1.5em' }} />
          Page Under Construction
        </h1>
        <p style={styles.description}>
          We're building something great here. Meanwhile, explore our Shirt of the Month!
        </p>
        <button
          style={styles.button}
          onClick={this.handleCTA}
          onMouseEnter={e => {
            const b = e.currentTarget.style;
            b.transform = 'scale(1.05)';
            b.boxShadow = '0 8px 16px rgba(0,0,0,0.3)';
            b.backgroundColor = '#D22328';
            b.color = '#FFF';
            b.borderColor = '#008e6a';
          }}
          onMouseLeave={e => {
            const b = e.currentTarget.style;
            b.transform = 'scale(1)';
            b.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
            b.backgroundColor = '#FFF';
            b.color = '#008e6a';
            b.borderColor = '#FFF';
          }}
        >
          <FaTshirt style={{ marginRight: '10px', verticalAlign: 'middle', fontSize: '1.2em' }} />
          Explore Shirt of the Month
        </button>
      </div>
    );
  }
}

export const ViewPapaJohnsDesigns = ViewPapaJohnsDesignsUC;

/*
====================================================
ORIGINAL VERSION (commented out for future reference)
====================================================

import { Component } from 'react';
import * as React from 'react';
import { FaPizzaSlice, FaArrowLeft } from 'react-icons/fa';
import { connect } from 'react-redux';
import * as Request from '../tgccRequest'; // Ensure this path is correct
import  PapaJohnsBannerImage  from './PapaJohnsBannerImage';
import { browserHistory } from 'react-router';
import Radium, { StyleRoot } from 'radium';

const colorMap = {
    kelly: '#4F946A',
    evergreen: '#30534D',
    red: '#B23947'
};

const styles: { [key: string]: React.CSSProperties } = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#f2f2f2',
        padding: '20px',
        textAlign: 'center',
    },
    title: {
        margin: '0 0 20px 0',
        fontSize: '2rem',
        color: '#333',
    },
    designsContainer: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', // Adjust the minmax values as needed
        gap: '20px',
        padding: '20px',
        maxWidth: '1200px',
        margin: 'auto',
      },
      designItem: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%', // full width of the column
        paddingBottom: '100%', // maintain a 1:1 aspect ratio
        justifyContent: 'center',
        position: 'relative',
        borderRadius: '10px',
        overflow: 'hidden',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        cursor: 'pointer',
        transition: 'transform 0.2s',
        ':hover': {
          transform: 'scale(1.05)',
          zIndex: 1,
          ':after': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
          },
          ' img': {
            transform: 'scale(1.1)',
          },
        },
      },
      designImage: {
        position: 'absolute', // position absolutely within designItem
        top: 0,
        padding: '25px',
        left: 0,
        width: '100%', // set to the width of the parent
        height: '100%', // set to the height of the parent (maintained by padding-top)
        objectFit: 'contain', // this prevents stretching
      },

    backButton: {
        backgroundColor: '#008e6a',
        color: 'white',
        padding: '10px 20px',
        fontSize: '16px',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        margin: '20px',
        textDecoration: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        '&:hover': {
            backgroundColor: '#007156', // Darker shade on hover
        },
    },
    topBar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        maxWidth: '1200px', // Keep consistent with your designs container
        margin: '0 auto 20px', // Adds margin below the top bar
    },
    colorSelectContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    colorSelectIcon: {
        cursor: 'pointer',
        margin: '0 10px',
        padding: '10px',
        border: '3px solid white', // Make it look more like a swatch
        borderRadius: '50%',
        width: '40px', // Size of the circle
        height: '40px', // Size of the circle
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    colorLabel: {
        marginTop: '5px',
        fontSize: '14px',
        color: '#fff',
        textTransform: 'capitalize',
    },
};

interface Props {
    designs?: string[];
}

class _ViewPapaJohnsDesigns extends React.Component<Props, any> {
    constructor(props: {}) {
        super(props);
        this.state = {
            designs: [],
            selectedColor: 'kelly',
        };
    }


    componentDidMount() {
        const colors: Array<keyof typeof colorMap> = ['kelly', 'red', 'evergreen'];
        const initialColor = colors[Math.floor(Math.random() * colors.length)]; // Randomly select one initial color
        this.fetchDesigns(initialColor);
    }
    

    fetchDesigns = (selectedColor: keyof typeof colorMap) => {
        // Assuming the Request.fetchPapaJohnsDesignsFromBlob function can handle fetching designs by color
        Promise.all([
            new Promise((resolve, reject) => {
                Request.fetchPapaJohnsDesignsFromBlob('raw-designs/shared', resolve, reject);
            }),
            new Promise((resolve, reject) => {
                Request.fetchPapaJohnsDesignsFromBlob(`raw-designs/${selectedColor}`, resolve, reject);
            })
        ]).then(results => {
            const designs = results.flat().reverse(); // Reverse the combined array of designs
            this.setState({ designs, selectedColor }); // Update state with reversed designs and the selected color
        }).catch(error => {
            console.error('Failed to fetch designs:', error);
        });

        this.renderDesigns();
    };
    


    setColor = (selectedColor: keyof typeof colorMap) => {
        this.setState({ selectedColor });
        this.fetchDesigns(selectedColor);
        // Optionally, you can also re-fetch or filter the designs based on the selected color
    };

    renderColorSelectors = () => {
        const { selectedColor } = this.state;
        const colors: Array<keyof typeof colorMap> = ['kelly', 'red', 'evergreen'];
        return (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <p style={{ fontWeight: 'bold', fontSize: '1rem', margin: '1rem', color: '#333' }}>
                    Select a Shirt Color:
                </p>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    {colors.map(color => (
                        <div key={color} style={{ margin: '0 10px', textAlign: 'center' }}>
                            <div
                                style={{
                                    ...styles.colorSelectIcon,
                                    backgroundColor: colorMap[color],
                                    border: selectedColor === color ? '3px solid white' : 'none',
                                }}
                                onClick={() => this.setColor(color)}
                                title={`Select ${color} color`}
                            >
                                <FaPizzaSlice color={selectedColor === color ? 'black' : 'white'} />
                            </div>
                            <span style={{ color: '#666', fontSize: '0.85rem' }}>{color}</span>
                        </div>
                    ))}
                </div>
            </div>
        );
    };
    
    


    renderDesigns = () => {
        const { designs, selectedColor } = this.state; // Destructure selectedColor from state
        return designs.map((designUrl, index) => (
            <div key={index} style={styles.designItem} onClick={() => this.handleDesignSelect(designUrl)}>
                <img className="viewPapaJohnsDesigns-design" src={designUrl} alt={`Design ${index + 1}`} style={{ ...styles.designImage, backgroundColor: colorMap[selectedColor] }} />
            </div>
        ));
    };

    handleDesignSelect = (designUrl) => {
        console.log('Selected design:', designUrl);
        // You can navigate to a detail view or do something else with the selected design URL here
    };

    render() {
        return (
          <div className="viewPapaJohnsDesigns-container">
            <PapaJohnsBannerImage />
            <div className="viewPapaJohnsDesigns-topBar" style={styles.topBar}>
              <div style={styles.backButtonContainer}>
                <a href="/papajohns/register" className="pj-getStartedBackBtn" style={styles.backButton}>
                  <FaArrowLeft style={{ marginRight: '8px' }} />
                  Get Started
                </a>
              </div>
              <div style={styles.colorSelectContainer}>
                {this.renderColorSelectors()}
              </div>
              // Empty div removed since we're using flex properties now
            </div>
            <div className="viewPapaJohnsDesigns-designs-container" style={styles.designsContainer}>
              {this.renderDesigns()}
            </div>
          </div>
        );
      }
}

const mapStateToProps = (state) => ({
});


export const OriginalViewPapaJohnsDesigns = connect(mapStateToProps)(Radium(_ViewPapaJohnsDesigns));

*/